import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: bookings.Session.
export default class Session extends Fragment {
  declare [Type]: 'bookings/session';

  @attr('number')
  declare startTime: number | undefined;

  @attr('number')
  declare endTime: number | undefined;
}
